import { IListCityResponse } from "../../../model/base/response/list-city-response";
import { IListStateResponse } from "../../../model/base/response/list-state-response";
import { IChangeUserPasswordRequest } from "../../../model/security/request/change-user-password-request";
import { IUpdateUserProfileRequest } from "../../../model/security/request/update-user-profile-request";
import { IUserProfileResponse } from "../../../model/security/response/user-profile-response";

export type ProfileState = {
  userProfileResponse?: IUserProfileResponse;
  listStateResponse?: IListStateResponse[];
  listCityResponse?: IListCityResponse[];
  userUpdateProfileRequest?: IUpdateUserProfileRequest;
  changePasswordRequest: IChangeUserPasswordRequest;
  fieldIsValid: boolean;
};

export enum ACTION_TYPES {
  setUserProfileResponse = 'setUserProfileResponse',
  setListStateResponse = 'setListStateResponse',
  setListCityResponse = 'setListCityResponse',
  setUserUpdateProfileRequest = 'setUserUpdateProfileRequest',
  setChangePasswordRequest = 'setChangePasswordRequest',
  setFieldIsValid = "setFieldIsValid",
}

export const ProfileReducer = (state: ProfileState, action: any): ProfileState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setUserProfileResponse:
      return {
        ...state,
        userProfileResponse: payload,
      };
    case ACTION_TYPES.setListStateResponse:
      return {
        ...state,
        listStateResponse: payload,
      };

    case ACTION_TYPES.setListCityResponse:
      return {
        ...state,
        listCityResponse: payload,
      };
    case ACTION_TYPES.setChangePasswordRequest:
      return {
        ...state,
        changePasswordRequest: payload,
      };
    case ACTION_TYPES.setUserUpdateProfileRequest:
      return {
        ...state,
        userUpdateProfileRequest: payload,
      };
      case ACTION_TYPES.setFieldIsValid:
        return {
          ...state,
          fieldIsValid: payload,
        };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}